import React, {useEffect} from 'react';
import type {NoProps} from 'types';
import {useLocalization} from 'localization';
import {useAuthState} from 'services/auth/hooks/useAuthState';
import {AppAnon} from '../../app/AppAnon';

type Props = NoProps;

export const Logout: React.FC<Props> = () => {
  const {logout} = useAuthState();
  const {t} = useLocalization();

  useEffect(() => {
    logout();
  }, [logout]);

  return <AppAnon>{t('page.login.redirect')}</AppAnon>;
};
